import React, { useEffect, useState } from 'react';
import { BasicFetch } from '../utils/BasicFetch.ts';
import '../css/login.css';

const RegisterForm = ({ showLogin }: { showLogin: (email: string) => void }) => {
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [password2, setPassword2] = useState<string>('');
  const [firstName, setFirstName] = useState<string>('');
  const [lastName, setLastName] = useState<string>('');
  const [breederName, setBreederName] = useState<string>('');
  const [passwordInvalid, setPasswordInvalid] = useState<boolean>(false);

  const register = () => {
    if (password !== password2 || password.length < 8) {
      setPasswordInvalid(true);
      return;
    }
    let formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);
    formData.append("breeder_name", breederName);
    formData.append("first_name", firstName);
    formData.append("last_name", lastName)

    BasicFetch(
      {
        url: `${(window as any).serverLocation}/user/create_account`,
        data: formData,
        method: 'POST',
        contentType: 'multipart/form-data',
        onSuccess: (data) => {
          if (data.success) {
            showLogin(email);
            alert("Successfully created account, you may now login.")
          } else {
            alert("There was an issue creating account. Please check your inputs and try again.")
          }
        },
        onFail: (data) => {
          alert("There was an issue creating account. Please try again later.")
        }
      })
  }

  return (
    <form id="register-form">
      <div className="">
        <h6>Email:</h6>
        <input id="email-data" value={email} onChange={(event) => setEmail(event.target.value)} type="email" className="form-control form-control-dark glow home-input" required autoComplete='email' />
      </div>
      <div className="text-center mt-3">
        <h6>Password:</h6>
        <input id="password" type="password" value={password} onChange={(event) => setPassword(event.target.value)} className="form-control form-control-dark glow home-input" required autoComplete='new-password' />
      </div>
      <div id="password2-container" className="text-center register-field has-validation mt-3">
        <h6>Confirm Password:</h6>
        <input id="password2" type="password" value={password2} onChange={(event) => setPassword2(event.target.value)} className={`form-control form-control-dark glow home-input ${passwordInvalid ? 'is-invalid' : ''}`} required autoComplete='new-password' />
        <div className='invalid-feedback'>Passwords must match and be atleast 8 characters long</div>
      </div>
      <div className="register-field mt-3">
        <h6>First Name:</h6>
        <input id="first-name-data" type="text" value={firstName} onChange={(event) => setFirstName(event.target.value)} className="form-control form-control-dark glow home-input" required autoComplete='given-name' />
      </div>
      <div className="register-field mt-3">
        <h6>Last Name:</h6>
        <input id="last-name-data" type="text" value={lastName} onChange={(event) => setLastName(event.target.value)} className="form-control form-control-dark glow home-input" required autoComplete='family-name' />
      </div>
      <div className="register-field mt-3">
        <div className="d-flex flex-row justify-content-center">
          <h6>Breeder Name: </h6><small className="text-light pt-1 mb-2 ml-2">(optional)</small>
        </div>
        <input id="breeder-name-data" value={breederName} onChange={(event) => setBreederName(event.target.value)} type="text" className="form-control form-control-dark glow home-input" />
      </div>
      <div className="home-button-container mt-4 d-flex flex-column">
        <div id="register-btn" className="login-button glow button" onClick={() => register()} >Register</div>
        <div onClick={() => showLogin(email)} className="cancel-btn login-button mr-2 glow button">Cancel</div>
      </div>
    </form>
  )
}

export const ResetPasswordForm = ({
  email = '',
  showLogin,
}: {
  email: string,
  showLogin: () => void,
}) => {
  const [resetEmail, setResetEmail] = useState<string>(email);
  const [resetting, setResetting] = useState<boolean>(false);

  useEffect(() => {
    if (resetting) {
      sendReset();
    }
  }, [resetting])
  const sendReset = () => {
    let formData = new FormData();
    formData.append("email", resetEmail);

    BasicFetch(
      {
        url: `${(window as any).serverLocation}user/reset_password`,
        data: formData,
        method: 'POST',
        contentType: 'multipart/form-data',
        onSuccess: (data) => {
          window.alert("Successfully requested password reset. Please check your email.")
          showLogin();
        },
        onFail: (data) => {
          window.alert("Failed to request password reset. Please try again later.")
        },
        onFinish: () => {
          setResetting(false);
        }
      })
  }
  return (
    <form id="reset-password-form">
      <div className="">
        <h6>Email:</h6>
        <input id="email-data" type="email" value={resetEmail} onChange={(event) => setResetEmail(event.target.value)} className="form-control form-control-dark glow home-input" required autoComplete='email' />
      </div>

      <div className="home-button-container mt-4 d-flex flex-column">
        {!resetting ? <div
          onClick={() => setResetting(true)}
          id="reset-password-btn"
          className="login-button glow button"
        >
          Request Reset Password Link
        </div> : <i className='fa fa-spinner fa-spin' />}
        <div onClick={showLogin} className="cancel-btn login-button mr-2 glow button">Cancel</div>
      </div>
    </form>
  )
}

export const LoginForm = ({
  showMenu,
  showRegister,
  showReset,
  presetEmail = '',
}: {
  presetEmail?: string,
  showMenu: () => void,
  showRegister: () => void,
  showReset: (email: string) => void,
}) => {
  const [email, setEmail] = useState<string | null>(presetEmail || localStorage.getItem("loginEmail"));
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(!!localStorage.getItem("loginEmail"))
  const login = () => {
    let formData = new FormData();
    formData.append("email", email || '');
    formData.append("password", password);
    BasicFetch(
      {
        url: `${(window as any).serverLocation}login`,
        data: formData,
        method: 'POST',
        contentType: 'multipart/form-data',
        onSuccess: (data) => {
          if (data.message === "Email not found or password is incorrect") {
            window.alert(data.message)
            throw Error();
          }
          showMenu();
          localStorage.setItem("reptoolCookie", data.token);
          (window as any).RepToolCookie = data.token; // for support of users who don't use localStorage
          if (remember) {
            localStorage.setItem("loginEmail", email || '');
          } else {
            localStorage.setItem("loginEmail", '');
          }
        },
        onFail: () => {
          window.alert("There was an error logging in")
        },
      })
  }
  return (
    <div>
      <div className="">
        <h6>Email:</h6>
        <input id="email-data" type="email" value={email || ''} onChange={(event) => setEmail(event.target.value)} className="form-control form-control-dark glow home-input" required autoComplete='email' />
      </div>
      <div className="text-center mt-3" >
        <h6>Password:</h6>
        <input id="password" type="password" value={password} onChange={(event) => setPassword(event.target.value)} className="form-control form-control-dark glow home-input" required autoComplete='current-password' />
      </div>
      <div className="text-center mt-3 d-flex flex-row justify-content-center">
        <input id="remember" type="checkbox" checked={remember} onClick={() => setRemember(!remember)} className="mr-2" />
        <div className="text-light">Remember Me Next Time</div>
      </div>
      <div className="home-button-container mt-4 d-flex flex-column">
        <input type="submit" id="login-btn" className="login-button glow button" onClick={() => login()} value="Login" />
        <div id="create-acct-btn" onClick={showRegister} className="login-button mt-3 glow button">Create Account</div>
        <div id="forgot-password" onClick={() => showReset(password)} className="text-light mt-2 mt-3">Forgot Your Password?</div>
      </div>
    </div>
  )
}
export const LoginContainer = ({ showMenu, showFrame = true }: {
  showMenu: () => void,
  showFrame?: boolean
}) => {
  const [showLogin, setShowLogin] = useState(true);
  const [showRegister, setShowRegister] = useState(false);
  const [showReset, setShowReset] = useState(false);
  const [currentEmail, setCurrentEmail] = useState<string | null>(localStorage.getItem("loginEmail"));

  return (
    <React.Fragment>
      {showFrame && <div className="bg-top">
        <img src="images/BG-Top.png" />
      </div>}
      <div className="p-4 mb-5 fadeIn animated">
        <div className="container login-container">
          <div id="logo" className="text-center columns">
            <img src="images/logo.svg" />
          </div>
          <h6 id="form-alert" className="hidden alert alert-success"></h6>
          <div className="text-center col col-md-6 mx-auto">
            {showLogin && <LoginForm
              showMenu={() => showMenu()}
              showRegister={() => { setShowLogin(false); setShowRegister(true) }}
              showReset={() => { setShowLogin(false); setShowReset(true) }}
              presetEmail={currentEmail || ''}
            />}
            {showRegister && <RegisterForm showLogin={(email) => { setCurrentEmail(email); setShowLogin(true); setShowRegister(false) }} />}
            {showReset && <ResetPasswordForm email={currentEmail || ''} showLogin={() => { setShowLogin(true); setShowReset(false) }} />}
          </div>
        </div>
      </div>
      {showFrame && <div className="bg-bottom position-relative">
        <img src="images/BG-bottom.png" />
      </div>}
    </React.Fragment>
  )
}
